document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    console.log(params)
    const sku = params.get("sku");
    console.log(sku);
    if (sku) {
      const messageField = document.getElementById("ContactForm-body");
      var sku_field = `<input type="hidden" name="product-sku" id="product-sku">`;

      document.querySelector("#product-sku").value = sku;
      document.querySelector("#product-sku").disabled = false;
      
      if (messageField) {
        messageField.value = `Product SKU: ${sku}`;
      }
    }
});